import dayjs from 'dayjs';
import { useState } from 'react';

import { STATISTIC_CONST } from '@/constant';
import { useMyWorkProjectPeriodMetricQuery } from '@/hook';
import {
  VFlex,
  VStack,
  VTab,
  VTabTrigger,
  VTabTriggerContainer,
} from '@/package';

import { calculatePeriodData, filterUnknownClass } from '../Statistic';
import { BarChart } from '../Statistic/BarChart';
import { RangePicker } from '../Statistic/RangePicker';
import type { PeriodUnit } from '../Statistic/type';

export const MyWorkProjectPeriodLabeledObject = () => {
  const [periodUnit, setPeriodUnit] = useState<PeriodUnit>('day');
  const [between, setBetween] = useState<[dayjs.Dayjs, dayjs.Dayjs]>([
    dayjs(STATISTIC_CONST.TODAY).subtract(12, 'week'),
    dayjs(STATISTIC_CONST.TODAY),
  ]);

  const { data: taskMetric } = useMyWorkProjectPeriodMetricQuery({
    period: periodUnit,
    between,
  });

  const extendClassList = taskMetric?.extendClass?.filter(filterUnknownClass);

  const periodData = calculatePeriodData(
    extendClassList,
    taskMetric?.userMetric,
  );

  return (
    <VStack gap={0.5} className="h-full w-full">
      <div className="text-headline-md font-bold text-blue-300">
        Total labeled objects
      </div>

      <VFlex className="w-full" justify="between" items="center">
        <div className="text-headline-sm font-semibold text-primary-500">
          Trend
        </div>
        <VFlex items="center" className="w-full" justify="end" gap={0.5}>
          <RangePicker
            value={between}
            onChange={setBetween}
            periodUnit={periodUnit}
            key={periodUnit}
          />

          <VTab
            defaultValue="day"
            onValueChange={val => setPeriodUnit(val as PeriodUnit)}
            value={periodUnit}
            size="small"
            variant="secondary"
          >
            <VTabTriggerContainer>
              <VTabTrigger value="day">Daily</VTabTrigger>
              <VTabTrigger value="week">Weekly</VTabTrigger>
              <VTabTrigger value="month">Monthly</VTabTrigger>
            </VTabTriggerContainer>
          </VTab>
        </VFlex>
      </VFlex>

      {periodData.length > 0 && (
        <BarChart data={periodData} periodUnit={periodUnit} between={between} />
      )}
    </VStack>
  );
};

MyWorkProjectPeriodLabeledObject.displayName =
  'MyWorkProjectPeriodLabeledObject';
